"use client";
import { MODAL_DURATIONS as y } from "../constants/modalDurations.js";
import { isSSR as k } from "../helpers/isSSR.js";
import { useState as c, useCallback as M, useEffect as O } from "react";
const T = ({
  closeDelay: f = y.out,
  interruptive: n = !1,
  onClose: e,
  open: t
}) => {
  if (k())
    return {
      willRender: !1,
      isOpen: !1,
      closeModal: () => {
      },
      targetElement: null
    };
  const [u, o] = c(t), [i, l] = c(!1), a = document == null ? void 0 : document.querySelector("body");
  function d() {
    n || (document.onkeyup = m), o(!0);
  }
  function s() {
    e == null || e(), r();
  }
  function r() {
    !n && document.onkeyup && (document.onkeyup = null);
  }
  const m = M((p) => {
    p.code === "Escape" && s();
  }, []);
  return O(() => (t ? (d(), setTimeout(() => {
    l(!0);
  })) : u == !0 && (l(!1), setTimeout(() => {
    o(!1), r();
  }, f)), () => {
    document != null && document.onkeyup && (document.onkeyup = null);
  }), [t]), {
    willRender: u,
    isOpen: i,
    closeModal: s,
    targetElement: a
  };
};
export {
  T as useModal
};
